export function getSessionStorage(itemKey) {
    const itemData = window.sessionStorage.getItem(itemKey)
    return itemData;
}

export function setSessionStorage(itemKey, payload) {
    window.sessionStorage.setItem(itemKey, payload)
}

export function removeSessionStorage(itemKey) {
    window.sessionStorage.removeItem(itemKey);
}